"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var diagnosticSchemaMap = {};
function addDiagnostics(uri, schema, monaco) {
  diagnosticSchemaMap[uri] = schema;
  var diagnosticOptions = {
    enableSchemaRequest: true,
    schemas: Object.entries(diagnosticSchemaMap).map(function (_a) {
      var u = _a[0],
        s = _a[1];
      return {
        fileMatch: [u],
        schema: s,
        uri: u
      };
    }),
    validate: true
  };
  monaco.languages.json.jsonDefaults.setDiagnosticsOptions(diagnosticOptions);
}
exports.addDiagnostics = addDiagnostics;